import { popDialog } from "@/store/dialogs-state"
import { useTranslation } from "react-i18next"
import { CullingGroup, CullingRejects, CullingSuggestion } from "../CullingPanels"
import { Dialog, DialogProps } from "../ui/Dialog"
import { Button } from "../ui/Button"
import { allPhotosAtom } from "@/store/photo/photos-state"
import { projectAtom } from "@/store/project/projects-state"
import { cullingSettingsAtom, suggestedKeeperCountAtom } from "@/store/importing/culling-state"
import { getCullingSettingsEventProperties } from "@/store/importing/culling-event-utils"
import { store } from "@/store/store"

export const CullingSettingsDialog = (
	props: Partial<DialogProps> & {
		onConfirm: () => void
		trackingProjectId?: string
		trackingTotalPhotos?: number
	},
) => {
	const { t } = useTranslation("components")
	const confirmCullingSettingsTrackingValues = () => {
		const project = store.get(projectAtom)
		const allPhotos = store.get(allPhotosAtom)
		const projectId = project?.id ?? props.trackingProjectId
		const totalPhotos =
			allPhotos.length > 0
				? allPhotos.length
				: (project?.photoCount ?? props.trackingTotalPhotos ?? 0)

		return {
			...(projectId ? { projectId } : {}),
			...getCullingSettingsEventProperties({
				cullingSettings: store.get(cullingSettingsAtom),
				suggestKeepersCount: store.get(suggestedKeeperCountAtom),
				totalCount: totalPhotos,
			}),
		}
	}

	return (
		<Dialog
			{...props}
			contentSize="sm-h-auto"
			trackingViewName="culling_settings_dialog"
			bottomButtons={
				<div className="flex w-full flex-1 flex-row items-center justify-end space-x-2">
					<Button
						trackingLabel="cancel"
						onClick={() => {
							popDialog()
						}}
					>
						{t("common:action.cancel")}
					</Button>

					<Button
						trackingLabel="confirm_culling_settings"
						aria-label={t("cullingSettingsDialog.ariaStartSmartCulling")}
						trackingValues={confirmCullingSettingsTrackingValues}
						variant="primary"
						onClick={() => {
							props.onConfirm()
						}}
					>
						{t("common:action.confirm")}
					</Button>
				</div>
			}
		>
			<div className="flex w-full max-w-full flex-col space-y-3 overflow-auto">
				<div className="flex flex-row items-center justify-between">
					<div className="text-md font-bold">
						{t("cullingSettingsDialog.cullingPreferences")}
					</div>
				</div>

				<div className="flex flex-col space-y-2 rounded-md bg-base-700/50 p-3 dark:bg-base-700">
					<CullingGroup isSetup={true} />
				</div>
				<div className="flex flex-col space-y-2 rounded-md bg-base-700/50 p-3 dark:bg-base-700">
					<CullingRejects isSetup={true} />
				</div>
				<div className="flex flex-col space-y-2 rounded-md bg-base-700/50 p-3 dark:bg-base-700">
					<CullingSuggestion isSetup={true} />
				</div>
			</div>
		</Dialog>
	)
}
